<template>
  <v-card class="cookie-consent-component">
    <v-card-title class="cookie-consent-title">
      {{ title }}
    </v-card-title>
    <v-card-text class="cookie-consent-content">
      <p>
        Your privacy is essential to us. You can customize how cookies are used
        on our site below:
      </p>

      <div class="consent-container">
        <div class="consent-option">
          <span>
            <h3 class="subtitle-2">Essential cookies</h3>
            <p class="caption">
              These cookies are necessary for the website to function and cannot
              be turned off.
            </p>
          </span>

          <span class="overline">ALWAYS ACTIVE</span>
        </div>
      </div>

      <div class="consent-container">
        <div class="consent-option">
          <button
            type="button"
            @click="onToggleConsent('analytics')"
          >
            <h3 class="subtitle-2">Performance & Analytics cookies</h3>
            <p class="caption">
              These cookies help us measure website visits and interactions with
              different pages, we use this information to improve our sites.
            </p>
          </button>

          <span>
            <v-switch
              v-model="localForm.analytics"
              :ripple="false"
            ></v-switch>
          </span>
        </div>
        <div class="consent-option">
          <button
            type="button"
            @click="onToggleConsent('preferences')"
          >
            <h3 class="subtitle-2">Functional cookies</h3>
            <p class="caption">
              These cookies enable us to implement additional functionality such
              as live chat support and CRM-based customization.
            </p>
          </button>

          <span>
            <v-switch
              v-model="localForm.preferences"
              :ripple="false"
            ></v-switch>
          </span>
        </div>
        <div class="consent-option">
          <button
            type="button"
            @click="onToggleConsent('marketing')"
          >
            <h3 class="subtitle-2">Targeting cookies</h3>
            <p class="caption">
              These cookies are used to help us and our advertising partners
              display relevant ads based on your usage of the site.
            </p>
          </button>

          <span>
            <v-switch
              v-model="localForm.marketing"
              :ripple="false"
            ></v-switch>
          </span>
        </div>
      </div>
    </v-card-text>
    <v-card-actions class="cookie-modal-actions">
      <v-btn
        text
        color="primary"
        :ripple="false"
        @click="onDeclineAll"
      >
        {{ actions.cancel }}
      </v-btn>

      <v-btn
        text
        color="primary"
        :ripple="false"
        @click="onSubmit"
      >
        {{ actions.confirm }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      title: 'Manage cookie settings',
      // Avoid mutating the prop directly, but allow the parent to
      // seed the form with defaults to keep it presentational
      localForm: { ...this.form },
      actions: {
        confirm: 'Save settings',
        cancel: 'Decline all',
      },
    };
  },
  methods: {
    onSubmit() {
      this.$emit('onSetConsent', this.localForm);
    },
    onDeclineAll() {
      this.$emit('onDeclineAll');
    },
    onToggleConsent(key) {
      this.localForm[key] = !this.localForm[key];
    }
  },
};
</script>

<style scoped lang="scss">
@import '../../../../legacy/scss/lib';

.cookie-consent-component {
  h2,
  h3,
  p,
  label {
    margin: 0;
  }

  p {
    // Hack for differences between signup and participant applications
    color: rgba(0, 0, 0, 0.60);
  }

  .consent-container {
    background: #fff;
  }

  .consent-option {
    button {
      text-align: left;
    }

    display: flex;
    padding: 13px 16px 17px 16px;
    align-items: center;
    gap: 16px;

    border: 1px solid #e9ecef;
    user-select: none;

    &:first-child:not(:only-child) {
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
      border-bottom: 0;
    }
    &:last-child:not(:only-child) {
      border-top: 0;
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
    }
    &:only-child {
      border-radius: 16px;
    }
  }

  // TODO move up and out into theme to create global style parity
  .subtitle-2 {
    @include typography-base(
      $color: rgba(0, 0, 0, 0.87),
      $font-weight: 500,
      $letter-spacing: 0.1px
    );
  }

  // TODO move up and out into theme to create global style parity
  .body-2 {
    @include typography-base($color: rgba(0, 0, 0, 0.6), $letter-spacing: 0.25px);
  }

  // TODO move up and out into theme to create global style parity
  .caption {
    @include typography-base(
      $color: rgba(0, 0, 0, 0.6),
      $font-weight: 400,
      $font-size: 12px,
      $letter-spacing: 0.4px
    );
  }

  // TODO move up and out into theme to create global style parity
  .overline {
    text-transform: uppercase;

    @include typography-base(
      $color: #000,
      $font-weight: 600,
      $font-size: 10px,
      $line-height: 16px,
      $letter-spacing: 1.5px
    );
  }

  .overline {
    white-space: nowrap;
  }

  .cookie-consent-title {
    padding-top: 24px;
    padding-bottom: 16px;
  }

  .cookie-consent-content {
    @include flex-stack();
    padding-bottom: 16px;
  }

  .cookie-modal-actions {
    @include flex-base($justify-content: flex-end, $align-items: center, $gap: 8px);
    padding: 0 24px 8px;
  }
}
</style>
